import React from 'react';
import { motion } from 'framer-motion';
import { Users, TrendingDown, DollarSign, Map, FileX, ShieldAlert, Laptop, UserX, ArrowRight } from 'lucide-react';
const painPoints = [{
  icon: Users,
  title: 'Driver shortages and recruiting churn'
}, {
  icon: TrendingDown,
  title: 'Client churn and inconsistent revenue'
}, {
  icon: DollarSign,
  title: 'Cash-flow delays and order-to-cash drag'
}, {
  icon: Map,
  title: 'Dispatch chaos and last-minute planning'
}, {
  icon: FileX,
  title: 'Back-office paperwork and manual errors'
}, {
  icon: ShieldAlert,
  title: 'Compliance, risk, and insurance pressure'
}, {
  icon: Laptop,
  title: 'Messy technology stack and poor visibility'
}, {
  icon: UserX,
  title: 'Leadership team stuck reacting instead of scaling'
}];
export function PainProblem() {
  return <section id="problems" className="section-padding bg-off-white relative" data-id="element-294">
      {/* Sharp angled divider top */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-steel to-transparent" data-id="element-295"></div>

      <div className="container-custom" data-id="element-296">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start" data-id="element-297">
          {/* Left Column: Sticky Context */}
          <div className="lg:col-span-5 lg:sticky lg:top-32" data-id="element-298">
            <span className="eyebrow" data-id="element-299">The Real Problem</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-navy mb-6 leading-tight" data-id="element-300">
              Most Carriers Don't Stall Because the Owner Is Lazy. They Stall
              Because Everything Depends on the Owner.
            </h2>
            <div className="w-16 h-1.5 bg-red mb-8" data-id="element-301"></div>
            <p className="text-lg text-body/80 leading-relaxed font-medium mb-8" data-id="element-302">
              When dispatch, driver issues, billing, compliance, customer
              follow-up, and technology all depend on the same few people,
              growth turns into pressure.
            </p>
            <p className="text-lg text-body/80 leading-relaxed mb-10" data-id="element-303">
              FleetScale helps you identify where the friction is and build a
              business that runs on process instead of constant firefighting.
            </p>
            <a href="#contact" className="btn-primary group hidden lg:inline-flex" data-id="element-304">
              Find My Bottleneck
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-305" />
            </a>
          </div>

          {/* Right Column: Editorial List */}
          <div className="lg:col-span-7" data-id="element-306">
            <div className="bg-white border border-steel shadow-xl rounded-sm overflow-hidden" data-id="element-307">
              <div className="bg-navy p-6 border-b border-white/10" data-id="element-308">
                <h3 className="text-white font-heading font-bold text-xl uppercase tracking-wider flex items-center" data-id="element-309">
                  <ShieldAlert className="w-5 h-5 text-red mr-3" data-id="element-310" />
                  Common Operational Bottlenecks
                </h3>
              </div>
              <div className="divide-y divide-steel/50" data-id="element-311">
                {painPoints.map((point, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.05
              }} className="p-5 sm:p-6 flex items-start hover:bg-off-white transition-colors group" data-id="element-312">
                    <div className="w-10 h-10 bg-steel/30 rounded flex items-center justify-center shrink-0 mr-5 group-hover:bg-red/10 group-hover:text-red transition-colors" data-id="element-313">
                      <point.icon className="w-5 h-5 text-navy group-hover:text-red transition-colors" data-id="element-314" />
                    </div>
                    <h4 className="text-navy font-bold text-lg leading-snug pt-1.5" data-id="element-315">
                      {point.title}
                    </h4>
                  </motion.div>)}
              </div>
            </div>

            <div className="mt-8 text-center lg:hidden" data-id="element-316">
              <a href="#contact" className="btn-primary group w-full sm:w-auto" data-id="element-317">
                Find My Bottleneck
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-318" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}